export default __webpack_public_path__ + "static/media/Edge of the Golden Age.d8e27c03.jpg";